import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Smartphone, Trash2, Plus } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/delivery-senders`;
const cfg = { withCredentials: true };

export const DeliverySenders = () => {
  const [senders, setSenders] = useState([]);
  const [number, setNumber] = useState('');
  const [phone, setPhone] = useState('');
  const [label, setLabel] = useState('');
  const [error, setError] = useState('');

  const load = () => axios.get(API, cfg).then((r) => setSenders(r.data)).catch(() => {});
  useEffect(() => {
    load();
    axios.get(`${API}/number`, cfg).then((r) => setNumber(r.data.number)).catch(() => {});
  }, []);

  const add = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await axios.post(API, { phone, label }, cfg);
      setPhone(''); setLabel(''); load();
    } catch (err) {
      setError(err.response?.data?.detail?.toString() || 'Numéro invalide');
    }
  };
  const remove = async (p) => {
    if (!window.confirm(`Retirer ${p}?`)) return;
    await axios.delete(`${API}/${encodeURIComponent(p)}`, cfg);
    load();
  };

  return (
    <div className="border rounded-xl p-5 bg-[#f8faf7] space-y-4" data-testid="delivery-senders">
      <div className="flex items-start gap-3">
        <Smartphone className="w-5 h-5 text-[#1a5c3b] mt-0.5" />
        <div>
          <h3 className="font-bold text-gray-900">Publier par texto</h3>
          <p className="text-sm text-gray-500">
            Envoyez une photo au <span className="font-semibold text-gray-800" data-testid="delivery-receiving-number">{number || '…'}</span> depuis un numéro autorisé : elle apparaît aussitôt sur le site. Texte « SUPPRIMER » pour retirer la dernière photo envoyée.
          </p>
        </div>
      </div>
      <form onSubmit={add} className="flex flex-col sm:flex-row gap-2">
        <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="514-555-1234" required
          className="border rounded-lg px-3 py-2 text-sm flex-1" data-testid="delivery-sender-phone-input" />
        <input value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Nom (optionnel)"
          className="border rounded-lg px-3 py-2 text-sm flex-1" data-testid="delivery-sender-label-input" />
        <button type="submit" className="bg-[#1a5c3b] hover:bg-[#165432] text-white text-sm font-semibold px-4 py-2 rounded-lg flex items-center justify-center gap-1" data-testid="delivery-sender-add-btn">
          <Plus className="w-4 h-4" /> Autoriser
        </button>
      </form>
      {error && <p className="text-sm text-red-600" data-testid="delivery-sender-error">{error}</p>}
      <ul className="divide-y bg-white rounded-lg border" data-testid="delivery-sender-list">
        {senders.length === 0 && <li className="p-3 text-sm text-gray-400">Aucun numéro autorisé</li>}
        {senders.map((s) => (
          <li key={s.phone} className="flex items-center justify-between p-3 text-sm" data-testid={`delivery-sender-${s.phone.replace('+', '')}`}>
            <span><span className="font-semibold">{s.phone}</span>{s.label && <span className="text-gray-500"> · {s.label}</span>}</span>
            <button onClick={() => remove(s.phone)} className="text-gray-400 hover:text-red-600" data-testid={`delivery-sender-remove-${s.phone.replace('+', '')}`}>
              <Trash2 className="w-4 h-4" />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
